export default "__VITE_ASSET__CN52pjnD__"